/**
 * JOEngagements — Trust band: Click&Collect, Livraison à domicile, Conseils, Devis gratuit
 * Highlights the e-commerce services for jardinerie + landscaper services for paysagiste.
 */
import React from "react";
import { Truck, Store, Headphones, FileCheck, Sprout, TreePine } from "lucide-react";
import { useUniverse } from "@/lib/jardins-ole/useUniverse";

const ITEMS_JARDINERIE = [
  {
    Icon: Store,
    title: "Click & Collect gratuit",
    text: "Commandez en ligne, retirez en boutique sous 2h ouvrées. Aucun frais.",
    badge: "2h",
  },
  {
    Icon: Truck,
    title: "Livraison à domicile",
    text: "Vos plantes livrées dans un rayon de 40 km, par notre équipe paysagiste.",
    badge: "40 km",
  },
  {
    Icon: Headphones,
    title: "Conseils d'experts",
    text: "Une question ? Notre équipe vous répond par téléphone, mail ou en boutique.",
    badge: "7j/7",
  },
  {
    Icon: Sprout,
    title: "Plantes garanties",
    text: "Reprise garantie sur l'ensemble de nos végétaux pendant 6 mois.",
    badge: "6 mois",
  },
];

const ITEMS_PAYSAGISTE = [
  {
    Icon: FileCheck,
    title: "Devis gratuit & détaillé",
    text: "Visite, métré, palette végétale, planning : un devis transparent et sans engagement.",
    badge: "48h",
  },
  {
    Icon: TreePine,
    title: "Visuel 3D inclus",
    text: "Avant validation, nous modélisons votre jardin pour que vous le voyiez en vrai.",
    badge: "3D",
  },
  {
    Icon: Headphones,
    title: "Suivi de chantier",
    text: "Un interlocuteur unique du devis à la réception, à votre écoute en permanence.",
    badge: "1 contact",
  },
  {
    Icon: Sprout,
    title: "Garantie de reprise",
    text: "Reprise des végétaux garantie 1 an après plantation par nos équipes.",
    badge: "1 an",
  },
];

export default function JOEngagements() {
  const { universe } = useUniverse();
  const items = universe === "paysagiste" ? ITEMS_PAYSAGISTE : ITEMS_JARDINERIE;
  const eyebrow = universe === "paysagiste" ? "— Notre méthode" : "— Nos engagements";
  const title = universe === "paysagiste"
    ? "Un projet maîtrisé,\nde la rencontre à la livraison"
    : "Du choix au pied de votre porte,\nsans mauvaise surprise";

  return (
    <section className="jo-section jo-section--alt" data-testid="jo-engagements">
      <div className="jo-container">
        <div className="max-w-2xl mb-12">
          <div className="jo-section-eyebrow">{eyebrow}</div>
          <h2 className="jo-section-title" style={{ whiteSpace: "pre-line" }}>{title}</h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((it, idx) => {
            const Icon = it.Icon;
            return (
              <div
                key={idx}
                className="jo-engagement-card"
                data-testid={`jo-engagement-${idx}`}
              >
                <div className="jo-engagement-icon">
                  <Icon className="w-6 h-6" strokeWidth={1.75} />
                </div>
                <div className="jo-engagement-badge">{it.badge}</div>
                <h3 className="jo-engagement-title">{it.title}</h3>
                <p className="jo-engagement-text">{it.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
